var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "couponList" }, [
      _c("div", { staticClass: "couponItem active" }, [
        _c("div", { staticClass: "couponItemTop" }, [
          _c("img", {
            attrs: {
              src: require("../../assets/images/indexLogo.png"),
              alt: ""
            }
          }),
          _vm._v(" "),
          _c("span", [_c("i", [_vm._v("￥")]), _vm._v("88")]),
          _vm._v(" "),
          _c("span", [_vm._v("使用条件：满20.00")]),
          _vm._v(" "),
          _c("span", [_vm._v("有效期：2020.12.30-2021.12.30")]),
          _vm._v(" "),
          _c("div", { staticClass: "couponType" }, [_vm._v("平台卷")])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "couponItemBot" }, [
          _vm._v("\n      限店铺使用\n      "),
          _c("span", { staticClass: "iconfont" }, [_vm._v("")])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-705d6809", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-705d6809","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/orderInfo/coupon.vue
// module id = null
// module chunks = 